import React, { useContext, } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { StringUtil } from 'ml-portals-util-js';

import metadata from './MLPolicyCoveragesComponent.metadata.json5';
import styles from '../MLClaimDetailPopup/MLClaimDetailPopup.module.scss';
import messages from './MLPolicyCoveragesComponent.messages';

import { IntlContext } from '@jutro/legacy/locale';

const MLPolicyCoveragesComponent = (props) => {
    const {
        policyCoverages,
        policyVehicles,
        policy
    } = props;
    const translator = useTranslator();
    const intl = useContext(IntlContext);

    const PERSONAL_AUTO_POLICY_TYPE = 'PersonalAuto';

    const formatAmountString = (amount) => {
        const premium = _.get(amount, 'amount', 0);
        const currency = _.get(amount, 'currency', 'usd');

        try {
            return intl.formatNumber(premium, { style: 'currency', currency });
        } catch (e) {
            return '';
        }
    }
    const formatVehicleDisplayName = (name) => {
        if (_.isUndefined(name)) {
            return;
        }
        name = name.toLowerCase();
        name = StringUtil.capitalizeFirstLetter(name);
        return name;
    };

    const getVehicleCoveragesOverrides = (vehicleCoverages) => {

        const vehicleCoverageOverrides = vehicleCoverages.map((coverage, index) => {
            return {
                [`coverageNameVeh${index}`]: {
                    content: (
                        <b>
                            {coverage.name}
                        </b>
                    )
                },
                [`incidentLimitVeh${index}`]: {
                    visible: coverage.exposureLimit  === undefined && coverage.incidentLimit !== undefined,
                    content: (formatAmountString(coverage.incidentLimit))
                },
                [`exposureLimitVeh${index}`]: {
                    visible: coverage.exposureLimit !== undefined && coverage.incidentLimit === undefined,
                    content: (formatAmountString(coverage.exposureLimit))
                },
                [`incidentAndExpoLimitVeh${index}`]: {
                    visible: coverage.exposureLimit !== undefined && coverage.incidentLimit !== undefined,
                    content: `${formatAmountString(coverage.exposureLimit)} / ${formatAmountString(coverage.incidentLimit)}`
                },
                [`deductibleVeh${index}`]: {
                    visible: coverage.deductible !== undefined,
                    content: (translator(messages.deductible, { amount: coverage.deductible ? formatAmountString(coverage.deductible) : '' }))
                }


            }
        });

        return Object.assign({}, ...vehicleCoverageOverrides);
    }


    const getCoverageOverrides = () => {
        const policyCoverageOverrides = policyCoverages.map((coverage, index) => {
            return {
                [`coverageName${index}`]: {
                    content: (
                        <b>
                            {coverage.name}
                        </b>
                    )
                },
                [`incidentLimit${index}`]: {
                    visible: coverage.exposureLimit === undefined && coverage.incidentLimit !== undefined,
                    content: (formatAmountString(coverage.incidentLimit))
                },
                [`exposureLimit${index}`]: {
                    visible: coverage.exposureLimit !== undefined && coverage.incidentLimit === undefined,
                    content: (formatAmountString(coverage.exposureLimit))
                },
                [`incidentAndExpoLimit${index}`]: {
                    visible: coverage.exposureLimit !== undefined && coverage.incidentLimit !== undefined,
                    content: `${formatAmountString(coverage.exposureLimit)} / ${formatAmountString(coverage.incidentLimit)}`
                }
            }
        });

        const vehiclesOverrides = _.isUndefined(policyVehicles) ? [] : policyVehicles.map((vehicle, index) => {
            return {
                [`vehicleName${index}`]: {
                    content: (
                        <span> <b> {vehicle.name} {formatVehicleDisplayName(vehicle.make)}</b>&nbsp; 
                            {formatVehicleDisplayName(vehicle.model)} {vehicle.trim_ML}
                        </span>
                    )
                },
                [`coveragesVehIterable${index}`]: {
                    data: vehicle.coverages
                },

                ...getVehicleCoveragesOverrides(vehicle.coverages)
            }
        });
        return Object.assign({}, ...policyCoverageOverrides, ...vehiclesOverrides);
    }

    const overrideProps = {
        policyNumber: {
            content: (<b>{translator(messages.policyNumber, { number: policy.policyNumber, state: policy.baseState_ML ? policy.baseState_ML.toUpperCase() : ''})}</b>)
        },
        coveragesIterable: {
            data: policyCoverages
        },
        vehicleCoveragesContainer: {
            visible: policy.policyType === PERSONAL_AUTO_POLICY_TYPE
        },
        vehiclesIterable : {
            data : policyVehicles
        },

        ...getCoverageOverrides()
    };
    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
};

MLPolicyCoveragesComponent.propTypes = {
    policy: PropTypes.object.isRequired,
    policyCoverages: PropTypes.arrayOf(PropTypes.object).isRequired,
    policyVehicles: PropTypes.arrayOf(PropTypes.object).isRequired
};


export default MLPolicyCoveragesComponent;
